import { SxProps, Theme } from "@mui/material";

export const styles = {
  dialogPaper: (isLgUp: boolean): SxProps<Theme> => ({
    width: "100%",
    maxWidth: 1256,
    maxHeight: isLgUp ? "min(852px, calc(100vh - 48px))" : "min(852px, calc(100vh - 24px))",
    borderRadius: "20px",
    boxShadow: "0px 32px 48px -8px rgba(0,0,0,0.1), 0px 0px 14px -4px rgba(0,0,0,0.05)",
    bgcolor: "#FFFFFF",
    position: "relative",
    m: isLgUp ? "24px" : "12px",
    padding: "62px 0",
    overflowY: "auto",
  }),

  closeButton: {
    position: "absolute",
    top: 20,
    right: 20,
    width: "22px",
    height: "22px",
    padding: 0,
  },

  dialogContent: {
    p: 0,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  headerWrapper: {
    maxHeight: "62px",
    minHeight: 0,
    width: "100%",
    maxWidth: 596,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
  },

  headerTitleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },

  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "34px",
    lineHeight: "40px",
    color: "#121212",
  },

  subtitle: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#9DA6B0",
  },

  contentWrapper: (isLgUp: boolean): SxProps<Theme> => ({
    mt: "34px",
    width: "100%",
    maxWidth: 1152,
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    px: isLgUp ? 0 : 2,
    overflowX: "hidden",
  }),

  topRow: {
    display: "flex",
    gap: "24px",
    width: "100%",
    justifyContent: "center",
    flexWrap: { xs: "wrap", md: "nowrap" },
  },

  topBlock: {
    maxWidth: "564px",
    flex: 1,
    height: 500,
    borderRadius: "16px",
    bgcolor: "#F0F0F0",
  },

  basicCard: {
    width: "100%",
    maxWidth: 564,
    height: 500,
    borderRadius: "16px",
    border: "1px solid #E7E7E7",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    pt: "20px",
    px: "20px",
    boxSizing: "border-box",
  },

  premiumCard: {
    position: "relative",
    overflow: "hidden",
    width: "100%",
    maxWidth: 564,
    height: 500,
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    pt: "20px",
    px: "20px",
    boxSizing: "border-box",
    background: "linear-gradient(180deg, #2A85FF 0%, #2A85FF 45%, #1D9BF0 55%, #1D9BF0 100%)",

    "&::before": {
      content: '""',
      position: "absolute",
      width: 96,
      height: 96,
      borderRadius: "50%",
      background: "rgba(255,255,255,0.1)",
      top: "476.63px",
      left: "-48px",
      pointerEvents: "none",
    },

    "&::after": {
      content: '""',
      position: "absolute",
      width: 128,
      height: 128,
      borderRadius: "50%",
      background: "rgba(255,255,255,0.1)",
      top: -64,
      left: "500px",
      pointerEvents: "none",
    },
  },

  planHeader: {
    width: "100%",
    maxWidth: 500,
    display: "flex",
    flexDirection: "column",
  },

  planTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  basicTitle: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "28px",
    lineHeight: "42px",
    color: "#000000",
  },

  premiumTitle: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "28px",
    lineHeight: "42px",
    color: "#FFFFFF",
  },

  basicSubtitle: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#7D8690",
  },

  premiumSubtitle: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "rgba(255,255,255,0.8)",
  },

  popularBadge: {
    height: 26,
    borderRadius: "9999px",
    px: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255,255,255,0.2)",
  },

  popularText: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "18px",
    textTransform: "uppercase",
    color: "#FFFFFF",
  },

  featuresPlaceholder: {
    width: "100%",
    maxWidth: 500,
    flexGrow: 1,
    bgcolor: "transparent",
  },

  bottomBlock: {
    borderRadius: "16px",
    border: "1px solid #E7E7E7",
    p: "20px",
    bgcolor: "#FFFFFF",
  },

  bottomInner: {
    width: "1110px",
    height: "70px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },

  bottomIcon: {
    width: "58px",
    height: "58px",
    borderRadius: "50%",
    bgcolor: "#8BC5F433",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
  },

  bottomTexts: {
    width: "667px",
    height: "56px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  bottomTitle: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "22px",
    lineHeight: "26px",
    color: "#121212",
  },

  bottomSubtitle: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#9DA6B0",
  },

  bottomRight: {
    display: "flex",
    alignItems: "center",
    gap: "24px",
  },

  priceBlock: {
    width: "195px",
    height: "70px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  priceRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "7px",
  },

  priceValue: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "44px",
    lineHeight: "52px",
    color: "#121212",
  },

  priceUnit: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "24px",
    lineHeight: "36px",
    color: "#9DA6B0",
  },

  priceNote: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "17px",
    letterSpacing: "1%",
    color: "#9DA6B0",
    textAlign: "right",
  },

  buyButton: {
    width: "146px",
    height: "54px",
    borderRadius: "28px",
    bgcolor: "#2A85FF",
    border: "none",
    cursor: "pointer",

    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#FFFFFF",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "&:hover": {
      bgcolor: "#1E6FE0",
    },
  },
};
